import React, {useState} from "react";
import IconButton from '@mui/material/IconButton';
import IconButtonSetting from "../../../../../../../components/Button/IconButtonSetting";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { Dis_TableData } from "./Get_Dis_table";


export default function Dis_Variants() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      

<IconButton onClick={handleOpen} size="small" >
            <IconButtonSetting />
</IconButton>

<CustomDialog open={open} onClose={handleClose}

title='Heart Desease - Variants'

content={ <Dis_TableData />}

/>

</>
)}